/* eslint-disable */
import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import multiguard from "vue-router-multiguard";
import { component } from "vue/types/umd";
import { authenticationGuard, adminGuard } from "./guards";
Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Welcome",
    components: {
      default: () => import("../ui/pages/Welcome.vue"),
    },
  },
  {
    path: "/auth",
    name: "Auth",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../ui/pages/Auth.vue"),
  },
  {
    path: "/pay/:id",
    name: "Pay",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "pay" */ "../ui/pages/Pay.vue"),
  },
  {
    path: "/pay2/:id",
    name: "Pay2",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "pay" */ "../ui/pages/Pay2.vue"),
  },
  {
    path: "/pay2/:id/card",
    name: "Pay2CreditCard",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import("../ui/pages/payment/CreditCardKbank.vue"),
  },
  {
    path: "/pay2/:id/qr",
    name: "Pay2QR",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import("../ui/pages/payment/QRKbank.vue"),
  },
  {
    // NOTE new Mastercard Gateway card flow (self-hosted form); /pay2 keeps the old one
    path: "/pay3/:id",
    name: "Pay3",
    component: () =>
      import(/* webpackChunkName: "pay3" */ "../ui/pages/Pay3.vue"),
  },
  {
    path: "/pay3/:id/card",
    name: "Pay3CreditCard",
    component: () =>
      import("../ui/pages/payment/CreditCardKbank.vue"),
  },
  {
    path: "/pay3/:id/qr",
    name: "Pay3QR",
    component: () =>
      import("../ui/pages/payment/QRKbank.vue"),
  },
  {
    path: "/thankyou",
    name: "Thankyou",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "pay" */ "../ui/pages/Thankyou.vue"),
  },
  // {
  //   path: "/chat",
  //   name: "SaleChat",
  //   component: () =>
  //     import(/* webpackChunkName: "pay" */ "../ui/pages/Thankyou.vue"),
  // },
  {
    path: "/chat/:tempkey",
    name: "GuestChat",
    component: () =>
      import(/* webpackChunkName: "pay" */ "../ui/pages/CustomerChatView.vue"),
  },
  {
    path: "/portal",
    name: "Portal",
    // route level code-s plitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "portal" */ "../ui/pages/Portal.vue"),
    children: [
      {
        path: "",
        name: "Home",
        components: {
          default: () => import("../ui/pages/CatalogGrid.vue"),
          searchbar: () => import("../ui/components/SearchBar.vue"),
          search: () => import("../ui/pages/Search.vue"),
        },
      },
      {
        path: "catalog",
        name: "AllProduct",
        components: {
          default: () => import("@/ui/pages/allProduct/AllProduct.vue"),
          categoryLevel1: () =>
            import("../ui/pages/allProduct/CategoryLevel1Bar.vue"),
          categoryLevel2: () =>
            import("../ui/pages/allProduct/CategoryLevel2Bar.vue"),
          categoryLevel3: () =>
            import("../ui/pages/allProduct/CategoryLevel3.vue"),
        },
        props: {
          default: true,
          categoryLevel1: true,
        },
      },
      // {
      //   path: "",
      //   components: {
      //     default: () => import("../ui/pages/home/Home.vue"),
      //     footer: () => import("../ui/components/MenuBar.vue"),
      //   }
      // },
      {
        path: "customer",
        name: "Customer",
        components: {
          default: () => import("../ui/pages/customer/Customer.vue"),
          footer: () => import("../ui/components/MenuBar.vue"),
        },
      },
      {
        path: "order",
        name: "OrderHistory",
        components: {
          default: () => import("@/ui/pages/order-history/OrderHistory.vue"),
        },
      },
      {
        path: "update-customer",
        name: "UpdateCustomer",
        components: {
          default: () => import("@/ui/pages/customer/UpdateCustomer.vue"),
        },
      },
      {
        path: "customer-detail/:id",
        name: "CustomerDetail",
        components: {
          default: () => import("@/ui/pages/customer/CustomerDetail.vue"),
        },
      },
      {
        path: "order/:id",
        name: "OrderDetail",
        components: {
          default: () => import("@/ui/pages/order-history/OrderDetail.vue"),
        },
      },
      {
        path: "tracking",
        name: "OrderTracking",
        components: {
          default: () => import("@/ui/pages/OrderTracking.vue"),
        },
      },
      {
        path: "cart",
        name: "Cart",
        components: {
          header: () => import("@/ui/pages/Cart/CartHeader.vue"),
          subheader: () => import("@/ui/pages/Cart/CartDeliveryFrom.vue"),
          default: () => import("@/ui/pages/Cart/Cart.vue"),
          footer: () => import("@/ui/pages/Cart/CartFooter.vue"),
        },
      },
      {
        path: "scan",
        name: "Scan",
        components: {
          // header: () => import("@/ui/pages/Cart/CartHeader.vue"),
          // subheader: () =>
          //     import("@/ui/pages/Cart/CartDeliveryFrom.vue"),
          default: () => import("@/ui/pages/Scan/Scan.vue"),
          // footer: () => import("@/ui/pages/Cart/CartFooter.vue"),
        },
      },
      {
        path: "checkout",
        name: "Checkout",
        components: {
          default: () => import("@/ui/pages/checkout/Checkout.vue"),
          footer: () => import("@/ui/pages/checkout/CheckoutFooter.vue"),
        },
        children: [
          {
            path: "",
            name: "Checkout",
            components: {
              shippingType: () =>
                import("@/ui/pages/checkout/ShippingType.vue"),
              shippingAddress: () =>
                import("@/ui/pages/checkout/ShippingAddress.vue"),
              deliverFrom: () => import("@/ui/pages/checkout/DeliverFrom.vue"),
              deliveryType: () =>
                import("@/ui/pages/checkout/DeliveryType.vue"),
              couponCode: () => import("@/ui/pages/checkout/CouponCode.vue"),
              voucherCode: () => import("@/ui/pages/checkout/VoucherCode.vue"),
              schedule: () => import("@/ui/pages/checkout/Schedule.vue"),
              orderSummary: () =>
                import("@/ui/pages/checkout/OrderSummary.vue"),
              commendToShoppers: () =>
                import("@/ui/pages/checkout/CommendToShoppers.vue"),
              options: () => import("@/ui/pages/checkout/Options.vue"),
              // default: () => import("../ui/pages/CatalogGrid.vue"),
              // searchbar: () => import("../ui/components/SearchBar.vue"),
              // search: () => import("../ui/pages/Search.vue"),
            },
          },
        ],
      },
      {
        path: "profile",
        name: "Profile",
        components: {
          default: () => import("@/ui/pages/Profile/Profile.vue"),
        },
      },
      {
        path: "create",
        name: "CreateCustomer",
        components: {
          default: () => import("@/ui/pages/customer/CreateCustomer.vue"),
        },
      },
      {
        path: "admin",
        name: "Admin",
        component: () => import("../ui/pages/Admin.vue"),
        beforeEnter: multiguard([adminGuard]),
      },
      {
        path: "branch-data",
        name: "AdminStat",
        component: () => import("../ui/pages/Stat/AdminStat.vue"),
        beforeEnter: multiguard([adminGuard]),
      },
      {
        path: "sale-stat",
        name: "SaleStat",
        component: () => import("../ui/pages/Stat/Stat.vue"),
        // beforeEnter: multiguard([]),
      },
      {
        path: "sale-data",
        name: "AllSaleStat",
        component: () => import("../ui/pages/Stat/AllSaleStat.vue"),
        beforeEnter: multiguard([adminGuard]),
      },
      {
        path: "customer-data",
        name: "CustomerStat",
        component: () => import("../ui/pages/Stat/CustomerStat.vue"),
        beforeEnter: multiguard([adminGuard]),
      },
      {
        path: "sales-by-customer",
        name: "SalesByCustomerStat",
        component: () => import("../ui/pages/Stat/SalesByCustomerStat.vue"),
        beforeEnter: multiguard([adminGuard]),
      },
      {
        path: "report",
        name: "Report",
        component: () => import("../ui/pages/report/Report.vue"),
        // beforeEnter: multiguard([]),
      },
      {
        path: "chat",
        name: "SaleChat",
        component: () => import("../ui/pages/chat/ChatView.vue"),
      },
      {
        path: "chat-dashboard",
        name: "SaleChatDashboard",
        component: () => import("../ui/pages/chat/DashboardView.vue"),
      },
    ],
    beforeEnter: multiguard([authenticationGuard]),
  },
  {
    path: "/wait-approve",
    name: "WaitApprove",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "WaitApprove" */ "../ui/pages/WaitApprove.vue"
      ),
  },
  {
    path: "/privacy-policy",
    name: "PrivacyPolicy",
    components: {
      default: () => import("../ui/pages/Privacy.vue"),
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
